import * as React from 'react';
import { Registry } from './Registry';
export var TypelessContext = React.createContext(null);
export var defaultRegistry = new Registry();
export var DefaultTypelessProvider = function (_a) {
    var children = _a.children;
    var value = React.useMemo(function () { return ({ registry: defaultRegistry }); }, []);
    return (React.createElement(TypelessContext.Provider, { value: value }, children));
};
//# sourceMappingURL=TypelessContext.js.map